module.exports = __webpack_public_path__ + "img/icon-download-2.72d0c335.svg";